import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { getPropiedadesAdmin } from "../../firebase/propiedades";
import { useAuth } from "../../context/AuthContext";
import logo from "../../logo.png";

const VERDE = "#1a9e2a";
const AZUL = "#1a3c5e";

function saludoSegunHora() {
  const h = new Date().getHours();
  if (h < 12) return "Buenos dias";
  if (h < 19) return "Buenas tardes";
  return "Buenas noches";
}

function formatearFecha() {
  const d = new Date();
  const dias = ["domingo", "lunes", "martes", "miercoles", "jueves", "viernes", "sabado"];
  const meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
  return dias[d.getDay()] + " " + d.getDate() + " de " + meses[d.getMonth()] + " de " + d.getFullYear();
}

export default function Dashboard() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [propiedades, setPropiedades] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    getPropiedadesAdmin().then((props) => {
      setPropiedades(props || []);
      setCargando(false);
    });
  }, []);

  const stats = useMemo(() => ({
    total: propiedades.length,
    disponibles: propiedades.filter((p) => p.estado === "Disponible").length,
    vendidas: propiedades.filter((p) => p.estado === "Vendida").length,
    alquiladas: propiedades.filter((p) => p.estado === "Alquilada").length,
    noDisponibles: propiedades.filter((p) => p.estado === "No disponible").length,
    enVenta: propiedades.filter((p) => p.operacion === "Venta").length,
    enAlquiler: propiedades.filter((p) => p.operacion === "Alquiler").length,
    casas: propiedades.filter((p) => p.tipo === "Casa").length,
    terrenos: propiedades.filter((p) => p.tipo === "Terreno").length,
    sinPrecio: propiedades.filter((p) => !p.precio || p.precio === 0).length,
    sinFotos: propiedades.filter((p) => !(p.imagenes && p.imagenes.length) && !p.imagen).length,
  }), [propiedades]);

  const masVisitadas = useMemo(() =>
    [...propiedades]
      .sort((a, b) => (b.visitas || 0) - (a.visitas || 0))
      .slice(0, 5),
    [propiedades]
  );

  async function handleLogout() {
    await logout();
    navigate("/admin/login");
  }

  const tarjetasStats = [
    { label: "Total", valor: stats.total, color: AZUL, fondo: "#eff6ff", borde: "#dbeafe" },
    { label: "Disponibles", valor: stats.disponibles, color: "#15803d", fondo: "#f0fdf4", borde: "#bbf7d0" },
    { label: "Vendidas", valor: stats.vendidas, color: "#dc2626", fondo: "#fef2f2", borde: "#fecaca" },
    { label: "Alquiladas", valor: stats.alquiladas, color: "#c2410c", fondo: "#fff7ed", borde: "#fed7aa" },
    { label: "No disponibles", valor: stats.noDisponibles, color: "#374151", fondo: "#f9fafb", borde: "#e5e7eb" },
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#f4f4f4", fontFamily: "system-ui, sans-serif" }}>

      <nav style={{
        background: "#fff",
        borderBottom: "1px solid #e5e5e5",
        padding: "12px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 100,
        gap: "12px",
      }}>
        <img src={logo} alt="Confalonieri Propiedades" onClick={() => navigate("/admin")} style={{ height: "40px", cursor: "pointer" }} />
        <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
          <button
            onClick={() => navigate("/")}
            style={{ background: "none", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "8px 14px", color: "#6b7280", fontSize: "13px", cursor: "pointer", fontWeight: "600" }}
          >
            Ver sitio
          </button>
          <button
            onClick={handleLogout}
            style={{ background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: "8px", padding: "8px 14px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}
          >
            Cerrar sesion
          </button>
        </div>
      </nav>

      <div style={{ height: "4px", background: VERDE }} />

      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "32px 20px" }}>

        {/* SALUDO */}
        <div style={{ marginBottom: "28px" }}>
          <p style={{ color: "#9ca3af", fontSize: "13px", margin: 0, textTransform: "capitalize" }}>
            {formatearFecha()}
          </p>
          <h1 style={{ fontSize: "28px", fontWeight: "700", color: AZUL, margin: "4px 0 0 0", fontFamily: "Georgia, serif" }}>
            {saludoSegunHora()}, panel de administracion
          </h1>
          <p style={{ color: "#6b7280", fontSize: "14px", margin: "6px 0 0 0" }}>
            {cargando ? "Cargando datos..." : "Tenes " + stats.total + " " + (stats.total === 1 ? "propiedad" : "propiedades") + " cargadas en el sistema."}
          </p>
        </div>

        {/* STATS */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "14px", marginBottom: "28px" }}>
          {tarjetasStats.map((t) => {
            const pct = stats.total > 0 ? Math.round((t.valor / stats.total) * 100) : 0;
            return (
              <div
                key={t.label}
                style={{ background: "#fff", border: "1px solid " + t.borde, borderRadius: "14px", padding: "18px 20px", cursor: "pointer", transition: "transform 0.15s, box-shadow 0.15s", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.04)"; }}
                onClick={() => navigate("/admin/propiedades")}
              >
                <p style={{ color: "#6b7280", fontSize: "12px", margin: 0, fontWeight: "600", letterSpacing: "0.5px", textTransform: "uppercase" }}>{t.label}</p>
                <p style={{ fontSize: "32px", fontWeight: "800", color: t.color, margin: "8px 0 4px 0", lineHeight: 1 }}>{t.valor}</p>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px", marginTop: "10px" }}>
                  <div style={{ flex: 1, height: "6px", background: t.fondo, borderRadius: "3px", overflow: "hidden" }}>
                    <div style={{ width: pct + "%", height: "100%", background: t.color, transition: "width 0.4s" }} />
                  </div>
                  <span style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "600", minWidth: "32px", textAlign: "right" }}>{pct}%</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* DISTRIBUCIONES */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "14px", marginBottom: "28px" }}>
          <div style={{ background: "#fff", borderRadius: "14px", padding: "20px", border: "1px solid #e5e7eb" }}>
            <h3 style={{ fontSize: "13px", fontWeight: "700", color: "#6b7280", margin: "0 0 16px 0", letterSpacing: "0.5px", textTransform: "uppercase" }}>Por operacion</h3>
            <BarraComparativa etiquetaA="Venta" valorA={stats.enVenta} colorA={AZUL} etiquetaB="Alquiler" valorB={stats.enAlquiler} colorB={VERDE} total={stats.total} />
          </div>
          <div style={{ background: "#fff", borderRadius: "14px", padding: "20px", border: "1px solid #e5e7eb" }}>
            <h3 style={{ fontSize: "13px", fontWeight: "700", color: "#6b7280", margin: "0 0 16px 0", letterSpacing: "0.5px", textTransform: "uppercase" }}>Por tipo</h3>
            <BarraComparativa etiquetaA="Casas" valorA={stats.casas} colorA="#7c3aed" etiquetaB="Terrenos" valorB={stats.terrenos} colorB="#ea580c" total={stats.total} />
          </div>
        </div>

        {/* ALERTAS */}
        {(stats.sinPrecio > 0 || stats.sinFotos > 0) && (
          <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "12px", padding: "14px 18px", marginBottom: "28px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>
            <div>
              <p style={{ margin: 0, fontSize: "13px", fontWeight: "700", color: "#92400e" }}>Atencion</p>
              <p style={{ margin: "2px 0 0 0", fontSize: "12px", color: "#a16207" }}>
                {stats.sinPrecio > 0 && stats.sinPrecio + " sin precio"}
                {stats.sinPrecio > 0 && stats.sinFotos > 0 && " - "}
                {stats.sinFotos > 0 && stats.sinFotos + " sin fotos"}
              </p>
            </div>
            <button onClick={() => navigate("/admin/propiedades")} style={{ background: "#f59e0b", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 14px", fontSize: "12px", fontWeight: "700", cursor: "pointer" }}>
              Revisar
            </button>
          </div>
        )}

        {/* MÁS VISITADAS */}
        <div style={{ background: "#fff", borderRadius: "14px", padding: "20px", border: "1px solid #e5e7eb", marginBottom: "28px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px" }}>
            <h3 style={{ fontSize: "13px", fontWeight: "700", color: "#6b7280", margin: 0, letterSpacing: "0.5px", textTransform: "uppercase" }}>
              Más visitadas
            </h3>
            <button onClick={() => navigate("/admin/propiedades")} style={{ background: "none", border: "none", color: VERDE, fontSize: "12px", fontWeight: "700", cursor: "pointer" }}>
              Ver todas
            </button>
          </div>

          {cargando ? (
            <p style={{ color: "#9ca3af", fontSize: "13px", margin: 0 }}>Cargando...</p>
          ) : masVisitadas.length === 0 ? (
            <div style={{ textAlign: "center", padding: "30px 10px" }}>
              <p style={{ color: "#9ca3af", fontSize: "13px", margin: "0 0 12px 0" }}>Todavia no hay propiedades cargadas</p>
              <button onClick={() => navigate("/admin/propiedades/nueva")} style={{ background: VERDE, color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: "700", cursor: "pointer" }}>
                Cargar la primera
              </button>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {masVisitadas.map((p) => {
                const img = (p.imagenes && p.imagenes[0]) || p.imagen;
                const colorEstado = p.estado === "Disponible" ? "#15803d" : p.estado === "Vendida" ? "#dc2626" : p.estado === "No disponible" ? "#374151" : "#c2410c";
                const fondoEstado = p.estado === "Disponible" ? "#f0fdf4" : p.estado === "Vendida" ? "#fef2f2" : p.estado === "No disponible" ? "#f9fafb" : "#fff7ed";
                return (
                  <div
                    key={p.id}
                    onClick={() => navigate("/admin/propiedades/editar/" + p.id)}
                    style={{ display: "flex", alignItems: "center", gap: "12px", padding: "10px", borderRadius: "10px", cursor: "pointer", transition: "background 0.15s" }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = "#f9fafb"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
                  >
                    <div style={{ width: "56px", height: "56px", borderRadius: "8px", background: img ? "url(" + img + ") center/cover" : "#e5e7eb", flexShrink: 0 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#111827", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {p.numeroProp ? `P1${p.numeroProp} · ` : ""}{p.titulo || "Sin titulo"}
                      </p>
                      <p style={{ margin: "2px 0 0 0", fontSize: "12px", color: "#6b7280", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {p.ubicacion || ""}{p.barrio ? " - " + p.barrio : ""}
                      </p>
                    </div>
                    <div style={{ textAlign: "right", flexShrink: 0 }}>
                      {p.precio > 0 ? (
                        <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: AZUL }}>${p.precio.toLocaleString()}</p>
                      ) : (
                        <p style={{ margin: 0, fontSize: "11px", color: "#9ca3af" }}>Sin precio</p>
                      )}
                      <p style={{ margin: "2px 0 0 0", fontSize: "11px", color: "#9ca3af" }}>
                        👁 {p.visitas || 0} {(p.visitas || 0) === 1 ? "visita" : "visitas"}
                      </p>
                      {p.estado && (
                        <span style={{ display: "inline-block", marginTop: "4px", fontSize: "10px", fontWeight: "700", color: colorEstado, background: fondoEstado, padding: "2px 8px", borderRadius: "20px" }}>
                          {p.estado}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* ACCIONES RAPIDAS */}
        <h3 style={{ fontSize: "13px", fontWeight: "700", color: "#6b7280", margin: "0 0 12px 0", letterSpacing: "0.5px", textTransform: "uppercase" }}>
          Acciones rapidas
        </h3>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "14px", marginBottom: "40px" }}>
          <BotonAccion icono="🏠" titulo="Propiedades" descripcion="Ver, editar y eliminar" onClick={() => navigate("/admin/propiedades")} color={AZUL} />
          <BotonAccion icono="➕" titulo="Nueva propiedad" descripcion="Publicar una nueva" onClick={() => navigate("/admin/propiedades/nueva")} color={VERDE} />
          <BotonAccion icono="✉" titulo="Consultas" descripcion="Mensajes de clientes" onClick={() => navigate("/admin/consultas")} color="#7c3aed" />
          <BotonAccion icono="$" titulo="Ingresos" descripcion="Libro de ingresos" onClick={() => navigate("/admin/ingresos")} color="#15803d" />
        </div>

      </div>

      <footer style={{ borderTop: "3px solid " + VERDE, padding: "20px", textAlign: "center", color: "#9ca3af", fontSize: "12px", background: "#fff" }}>
        Confalonieri Propiedades - Panel de administracion
      </footer>

    </div>
  );
}

function BarraComparativa({ etiquetaA, valorA, colorA, etiquetaB, valorB, colorB, total }) {
  const sumaAB = valorA + valorB;
  const pctA = sumaAB > 0 ? Math.round((valorA / sumaAB) * 100) : 0;
  const pctB = sumaAB > 0 ? 100 - pctA : 0;
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
        <span style={{ fontSize: "13px", color: colorA, fontWeight: "700" }}>{etiquetaA}</span>
        <span style={{ fontSize: "13px", color: "#111827", fontWeight: "700" }}>{valorA}</span>
      </div>
      <div style={{ height: "8px", background: "#f3f4f6", borderRadius: "4px", overflow: "hidden", marginBottom: "12px" }}>
        <div style={{ width: pctA + "%", height: "100%", background: colorA, transition: "width 0.4s" }} />
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
        <span style={{ fontSize: "13px", color: colorB, fontWeight: "700" }}>{etiquetaB}</span>
        <span style={{ fontSize: "13px", color: "#111827", fontWeight: "700" }}>{valorB}</span>
      </div>
      <div style={{ height: "8px", background: "#f3f4f6", borderRadius: "4px", overflow: "hidden" }}>
        <div style={{ width: pctB + "%", height: "100%", background: colorB, transition: "width 0.4s" }} />
      </div>
      {total > 0 && sumaAB < total && (
        <p style={{ margin: "10px 0 0 0", fontSize: "11px", color: "#9ca3af" }}>{total - sumaAB} sin clasificar</p>
      )}
    </div>
  );
}

function BotonAccion({ icono, titulo, descripcion, onClick, color }) {
  return (
    <button
      onClick={onClick}
      style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "14px", padding: "20px", textAlign: "left", cursor: "pointer", transition: "transform 0.15s, box-shadow 0.15s, border-color 0.15s", display: "flex", flexDirection: "column", gap: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = color; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.04)"; e.currentTarget.style.borderColor = "#e5e7eb"; }}
    >
      <div style={{ fontSize: "28px", lineHeight: 1 }}>{icono}</div>
      <div>
        <p style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: "#111827" }}>{titulo}</p>
        <p style={{ margin: "2px 0 0 0", fontSize: "12px", color: "#6b7280" }}>{descripcion}</p>
      </div>
    </button>
  );
}
